import { useEffect, useState } from 'react';
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import system from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import dayjs from 'dayjs';
import { render } from '@testing-library/react';
import moment from 'moment';
import getList from '../../universal/getList';

const { RangePicker } = DatePicker;

export default function QuotationComparison() {
    const wmService: any = system.wmService;

    const [rows, setRows] = useState<any[]>([]);
    const [userName, setUserName] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [expandedKeys, setExpandedKeys] = useState<Record<string, boolean>>({});
    const [subDataMap, setSubDataMap] = useState<Record<string, any[]>>({});
    const [form] = Form.useForm();
    let submissionTime = Form.useWatch("submissionTime", form)
    const [quotationNotice, setQuotationNotice] = useState<any>();

    const columnsHead = [
        {
            title: '产品',
            dataIndex: 'productName',
            key: 'productName',
            width: 200,
        },
        {
            title: '单位',
            dataIndex: 'productUnitName',
            key: 'productUnitName',
            width: 100,
        },
    ];

    useEffect(() => {
        form.setFieldValue('submissionTime', [
            dayjs().subtract(1, 'month').startOf('day'),
            dayjs().endOf('day'),
        ]);
        const fetchData = async () => {
            fetchApi.GET(wmService,
                {
                    apiId: 'quotationNotice',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {

                        setQuotationNotice(res.data);
                    }
                });

        };
        fetchData();
    }, []);

    const onFinish = () => {
        setIsLoading(true);

        form.validateFields().then(values => {
            fetchApi.GET(wmService, {
                apiId: 'quotationOrder',
                apiExtend: 'quotationProductComparison',
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    },
                    ...values
                }
            })
                .then((res: any) => {
                    if (res.success) {
                        setRows(res.data);
                        setUserName(res.userName);
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    antMessage('error', '失败', err.message);
                    setIsLoading(false);
                });
        });
    };

    /** 展开时请求子表 */
    const onExpand = async (expanded: boolean, record: any) => {
        if (!expanded) return;
        if (expandedKeys[record.productName + record.productUnitName]) return;

        try {
            const res: any = await fetchApi.GET(wmService, {
                apiId: 'quotationOrder',
                apiExtend: 'quotationProductComparisonDetail', // ✅ 换成你的真实接口
                apiData: {
                    quotationNoticeId:form.getFieldValue("quotationNoticeId"),
                    productName: record.productName,
                    productUnitName: record.productUnitName,
                    submissionTime,
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    }
                },
            });

            setSubDataMap(prev => ({
                ...prev,
                [record.productName + record.productUnitName]: res.data || [],
            }));

            setExpandedKeys(prev => ({
                ...prev,
                [record.productName + record.productUnitName]: true,
            }));
        } catch (err: any) {
            antMessage('error', '子表加载失败', err.message);
        }
    };

    /** 子表渲染 */
    const expandedRowRender = (record: any) => {
        const subColumns: any = [
            { title: '来源', dataIndex: 'displayName' },
            { title: '单价', dataIndex: 'price' },
            { title: '规格', dataIndex: 'productSpecifications' },
            { title: '备注', dataIndex: 'memo' },
            { title: '联系方式', dataIndex: 'mobile' },
            // { title: '报价单号', dataIndex: 'id' },
            { title: '提交时间', dataIndex: 'submissionTime', render: (text: any) => { return <div>{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : null}</div> } },

        ];

        return (
            <Table
                rowKey="id"
                columns={subColumns}
                dataSource={subDataMap[record.productName + record.productUnitName] || []}
                pagination={false}
                size="small"
                loading={!subDataMap[record.productName + record.productUnitName]}
            />
        );
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item name="submissionTime" label="日期">
                            <RangePicker format="YYYY-MM-DD" />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="quotationNoticeId" label="公告">
                            <Select
                                showSearch
                                allowClear
                                placeholder="公告"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.generalEx(quotationNotice, { itemName: "quotationNoticeName", includeNull: true })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="queryString" label="查询">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item>
                            <Space>
                                <Button type="primary" loading={isLoading} htmlType="submit">
                                    统计
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <div style={{ marginTop: 20 }}>
                <Table
                    rowKey="totalName"
                    columns={columnsHead}
                    dataSource={rows}
                    pagination={false}
                    expandable={{
                        onExpand,
                        expandedRowRender,
                        expandIconColumnIndex: 0,
                    }}
                />
            </div>
        </div>
    );
}